import { mutationFactory } from 'vuex-factories'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    talentPoolEntry: {},
  },
  getters: {},
  actions,
  mutations: {
    ...mutationFactory({
      SET_TALENT_POOL_ENTRY_DATA: [{ key: 'talentPoolEntry' }],
    }),
  },
}
